<div
	class="c-list"
	[ngClass]="{
		'is--ordered': this.listStyle === 'ordered',
		'is--unordered': this.listStyle === 'unordered'
	}"
	role="list"
>
	<ng-content select="qe-list-item"></ng-content>
</div>
